import axios from "axios";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useBannerContext } from "oolib";
import { useGenErrorMsgBanners } from "@/utils/useGenErrorMsgBanners";

/**
 * Cohorts: named, tenant-wide saved combinations of FilterModule activeFilters.
 * Applying one is just handing its `activeFilters` array back to setActiveFilters.
 */
export const useGetCohorts = ({ enabled = true } = {}) =>
  useQuery(
    "cohorts",
    () => axios.get("/api/cohorts").then((r) => r.data.cohorts),
    { staleTime: 5 * 60 * 1000, enabled }
  );

export const useCreateCohort = () => {
  const queryClient = useQueryClient();
  const { SET_INFO_BANNER } = useBannerContext();
  const { genErrorMsgBanners } = useGenErrorMsgBanners();
  return useMutation(
    ({ name, activeFilters }) =>
      axios.post("/api/cohorts", { name, activeFilters }).then((r) => r.data.cohort),
    {
      onSuccess: (cohort) => {
        queryClient.invalidateQueries("cohorts");
        SET_INFO_BANNER({ color: "green", msg: `Cohort "${cohort.name}" saved`, timeOut: 3000 });
      },
      onError: (err) => genErrorMsgBanners({ err }),
    }
  );
};

export const useDeleteCohort = () => {
  const queryClient = useQueryClient();
  const { SET_INFO_BANNER } = useBannerContext();
  const { genErrorMsgBanners } = useGenErrorMsgBanners();
  return useMutation(
    ({ cohortId }) => axios.delete(`/api/cohorts/${cohortId}`).then((r) => r.data.cohort),
    {
      onSuccess: (cohort) => {
        queryClient.invalidateQueries("cohorts");
        SET_INFO_BANNER({ color: "green", msg: `Cohort "${cohort.name}" deleted`, timeOut: 3000 });
      },
      onError: (err) => genErrorMsgBanners({ err }),
    }
  );
};
